/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const monitoringIntegrationPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const monitoringIntegrationPageResponseOutputItemsItemVersionExclusiveMin = 0;
export const monitoringIntegrationPageResponseOutputItemsItemVersionMax = 9007199254740991;

export const monitoringIntegrationPageResponseOutputItemsItemTeamOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const monitoringIntegrationPageResponseOutputItemsItemDefaultCustomerOneIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );

export const monitoringIntegrationPageResponseOutputItemsItemPriorityPolicyOnePriorityMax = 4;

export const monitoringIntegrationPageResponseOutputItemsItemPriorityPolicyTwoDefaultPriorityMax = 4;

export const monitoringIntegrationPageResponseOutputItemsItemLastMessageOneReceivedAtRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
  );
export const monitoringIntegrationPageResponseOutputItemsItemLastMessageOneIncidentIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const monitoringIntegrationPageResponseOutputItemsMax = 100;

export const monitoringIntegrationPageResponseOutputNextCursorOneMax = 512;

export const monitoringIntegrationPageResponseOutputNextCursorOneRegExp = new RegExp(
  '^[A-Za-z0-9_-]+$',
);

export const MonitoringIntegrationPageResponseOutput = zod.object({
  items: zod
    .array(
      zod.object({
        id: zod.uuid().regex(monitoringIntegrationPageResponseOutputItemsItemIdRegExp),
        name: zod.string(),
        provider: zod.enum(['checkly', 'datadog', 'grafana', 'prtg']),
        state: zod.enum(['disabled', 'enabled', 'retired']),
        version: zod
          .int()
          .gt(monitoringIntegrationPageResponseOutputItemsItemVersionExclusiveMin)
          .max(monitoringIntegrationPageResponseOutputItemsItemVersionMax),
        team: zod.union([
          zod.object({
            id: zod.uuid().regex(monitoringIntegrationPageResponseOutputItemsItemTeamOneIdRegExp),
            name: zod.string(),
          }),
          zod.null(),
        ]),
        defaultCustomer: zod.union([
          zod.object({
            id: zod
              .uuid()
              .regex(monitoringIntegrationPageResponseOutputItemsItemDefaultCustomerOneIdRegExp),
            name: zod.string(),
          }),
          zod.null(),
        ]),
        credentialLabel: zod.union([zod.string().min(1), zod.null()]),
        priorityPolicy: zod.union([
          zod.object({
            mode: zod.literal('fixed'),
            priority: zod
              .int()
              .min(1)
              .max(monitoringIntegrationPageResponseOutputItemsItemPriorityPolicyOnePriorityMax),
          }),
          zod.object({
            mode: zod.literal('payload'),
            field: zod.string().nullable(),
            defaultPriority: zod
              .int()
              .min(1)
              .max(
                monitoringIntegrationPageResponseOutputItemsItemPriorityPolicyTwoDefaultPriorityMax,
              ),
          }),
        ]),
        readiness: zod.enum(['ready', 'not-ready', 'unavailable']),
        lastMessage: zod.union([
          zod.object({
            receivedAt: zod.iso
              .datetime({ offset: true })
              .regex(
                monitoringIntegrationPageResponseOutputItemsItemLastMessageOneReceivedAtRegExp,
              ),
            outcome: zod.enum(['created', 'retry', 'grouped', 'ignored', 'refused', 'unavailable']),
            incidentId: zod.union([
              zod
                .uuid()
                .regex(
                  monitoringIntegrationPageResponseOutputItemsItemLastMessageOneIncidentIdOneRegExp,
                ),
              zod.null(),
            ]),
          }),
          zod.null(),
        ]),
      }),
    )
    .max(monitoringIntegrationPageResponseOutputItemsMax),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(monitoringIntegrationPageResponseOutputNextCursorOneMax)
      .regex(monitoringIntegrationPageResponseOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type MonitoringIntegrationPageResponseOutput = zod.input<
  typeof MonitoringIntegrationPageResponseOutput
>;
export type MonitoringIntegrationPageResponseOutputOutput = zod.output<
  typeof MonitoringIntegrationPageResponseOutput
>;
